import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const ClipboardIcon = ({
  size = 16,
  color = coalColor,
  className,
  variant = "filled",
}: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={variant === "filled" ? "0 0 12 13" : "0 0 16 16"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {variant === "filled" ? (
        <path
          d="M2.2745 1.683V4.049H9.3725V1.683H10.5594C10.8839 1.683 11.147 1.94619 11.147 2.2706V11.7424C11.147 12.0669 10.8838 12.33 10.5594 12.33H1.0876C0.763076 12.33 0.5 12.0668 0.5 11.7424V2.2706C0.5 1.94608 0.763188 1.683 1.0876 1.683H2.2745ZM4.049 9.3725H2.866V10.5555H4.049V9.3725ZM4.049 7.598H2.866V8.781H4.049V7.598ZM4.049 5.8235H2.866V7.0065H4.049V5.8235ZM8.1895 0.5V2.866H3.4575V0.5H8.1895Z"
          fill={color}
          strokeWidth="0"
        />
      ) : (
        <path
          d="M11.3333 1.33301V2.66634H13.3377C13.7035 2.66634 14 2.96297 14 3.32861V14.0041C14 14.3698 13.7034 14.6663 13.3377 14.6663H2.66227C2.29651 14.6663 2 14.3697 2 14.0041V3.32861C2 2.96285 2.29663 2.66634 2.66227 2.66634H4.66667V1.33301H11.3333ZM4.66667 3.99967H3.33333V13.333H12.6667V3.99967H11.3333V5.33301H4.66667V3.99967ZM6 10.6663V11.9997H4.66667V10.6663H6ZM6 8.66634V9.99967H4.66667V8.66634H6ZM6 6.66634V7.99967H4.66667V6.66634H6ZM10 2.66634H6V3.99967H10V2.66634Z"
          fill={color}
          strokeWidth="0"
        />
      )}
    </svg>
  );
};
